import { useState } from "react";
import { Button, Modal } from "flowbite-react";
import { HiMoon } from "react-icons/hi2";
import {
  SNOOZE_DURATIONS,
  snoozeUntilISO,
  formatDate,
} from "../signalLifecycle";

const DEFAULT_DURATION = SNOOZE_DURATIONS[0].value;

/**
 * Snooze duration picker. Replaces the old inline dropdown so snooze gets the
 * same deliberate modal treatment as resolve.
 *
 * @param {boolean}  show
 * @param {boolean}  [loading]
 * @param {Function} onConfirm - (snoozeUntilISO) => void
 * @param {Function} onCancel
 */
export const SnoozeSignalModal = ({ show, loading, onConfirm, onCancel }) => {
  const [selected, setSelected] = useState(DEFAULT_DURATION);
  const chosen =
    SNOOZE_DURATIONS.find((d) => d.value === selected) ?? SNOOZE_DURATIONS[0];
  const until = snoozeUntilISO(chosen.days);

  return (
    <Modal show={show} popup onClose={onCancel} size="md">
      <Modal.Header />
      <Modal.Body>
        <div className="text-center">
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-gray-100">
            <HiMoon className="h-6 w-6 text-gray-500" />
          </div>
          <h3 className="mb-1 text-lg font-semibold text-gray-900">
            Snooze signal
          </h3>
          <p className="mb-4 text-sm text-gray-500">
            Hide this signal until the selected date. It returns to Active
            automatically.
          </p>

          <div className="mb-4 grid grid-cols-2 gap-2">
            {SNOOZE_DURATIONS.map(({ value, label }) => (
              <button
                key={value}
                type="button"
                data-testid={`snooze-option-${value}`}
                aria-pressed={selected === value}
                onClick={() => setSelected(value)}
                className={`rounded-lg border px-3 py-2 text-sm font-medium transition-colors ${
                  selected === value
                    ? "border-blue-500 bg-blue-50 text-blue-700"
                    : "border-gray-200 bg-white text-gray-600 hover:bg-gray-50"
                }`}
              >
                {label}
              </button>
            ))}
          </div>

          <p className="mb-5 text-xs text-gray-400">
            Until {formatDate(until)}
          </p>

          <div className="flex justify-center gap-4">
            <Button color="gray" onClick={onCancel} disabled={loading}>
              Cancel
            </Button>
            <Button
              color="blue"
              data-testid="snooze-confirm"
              onClick={() => onConfirm(until)}
              disabled={loading}
            >
              Snooze
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
